"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.color = void 0;
const picocolors_1 = __importDefault(require("picocolors"));
function color(text, opts) {
    switch (opts.mode) {
        case "escape-code": {
            if (opts.color === "red")
                text = picocolors_1.default.bold(picocolors_1.default.red(text));
            if (opts.background === "red")
                text = picocolors_1.default.bgRed(text);
            return text;
        }
        case "html": {
            if (opts.color === "red")
                text = `<span style="color: red;">${text}</span>`;
            if (opts.background === "red")
                text = `<span style="border-bottom: 2px solid red;">${text}</span>`;
            return text;
        }
        default: {
            console.log(`[utils.color] unknown mode: ${opts.mode}`);
            return text;
        }
    }
}
exports.color = color;
//# sourceMappingURL=color.js.map